<div class="container-text">
    <div class="container-header d-flex">
        <img class="" src="assets/images/icons/bullhorn.svg" alt="aviso">
        <p class="align-items-center">Bem-vindo ao portal de Documentos do IR</p>
    </div>
    <div class="container-content-text">
        <p>Neste espaço você poderá acessar os documentos necessários para a declaração IRPF deste ano. Se você possui
            previdência e plano de saúde,
            <strong>certifique-se de navegar até o final da página</strong> para ver todos os documentos
            disponibilizados.
        </p>
        <p>Para maiores informações, consulte nosso <a href="https://www.vivest.com.br/site/paginas/portal-de-declaracao-de-imposto-de-renda" target="_blank">espaço exclusivo sobre o Imposto de Renda clicando aqui</a></p>
    </div>
</div>